import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class KioskCategoryService {
  constructor(private http: HttpClient) {}

  // Get all kiosk categories
  public getAllKioskCategories(pagination, sort) {
    const sortString = '&sort=' + sort;

    let paginationString = '';
    paginationString += '?size=' + pagination.size;
    paginationString += '&page=' + pagination.page;

    return this.http
      .get(environment.apiUrl + 'api/ext-item-category-kiosk' + paginationString + sortString, { observe: 'response' })
      .pipe(map(this.handleDataWithHeaders))
      .pipe(catchError(this.handleError));
  }

  // Get all kiosk categories with no pagination (for lists and dropdowns)
  public getAllKioskCategoriesNoPagination() {
    let paginationString = '';
    paginationString += '?size=' + 10000;
    paginationString += '&page=' + 0;
    return this.http
      .get(environment.apiUrl + 'api/ext-item-category-kiosk' + paginationString)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Get Kiosk Categories by Store Id
  public getItemKioskCategoriesByStoreId(id) {
    let paginationString = '';
    paginationString += '?size=' + 10000;
    paginationString += '&page=' + 0;

    const sortString = '&sort=description,asc';

    return this.http
      .get(environment.apiUrl + 'api/ext-item-category-kiosk/by-store/' + id + paginationString + sortString)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Create Kiosk Category
  public createKioskCategory(obj) {
    const body = {
      name: obj.name,
      description: obj.description,
      enabled: true,
      parentItemCategoryId: obj.parentItemCategoryId,
      storeId: obj.storeId,
    };

    return this.http
      .post(environment.apiUrl + 'api/ext-item-category-kiosk', body)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Edit Kiosk Category
  public editKioskCategory(obj) {
    return this.http
      .put(environment.apiUrl + 'api/ext-item-category-kiosk', obj)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // HANDLE DATA
  private handleData(res: HttpResponse<any>) {
    const body = res;
    return body;
  }

  public handleDataWithHeaders(res: HttpResponse<any>) {
    const headers = res.headers;
    const body = res.body;
    const data = {
      headers: headers,
      body: body,
    };
    return data;
  }

  private handleError(error: any) {
    return Observable.throw(new HttpErrorResponse(error));
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/kiosk-category.service.ts